import React from 'react';
import { UrlEncoder } from '../components/url-encoder/UrlEncoder';

export const UrlEncoderPage: React.FC = () => {
  return (
    <div className="page-container">
      <UrlEncoder />
    </div>
  );
};